import { useConfig } from "$global-providers/config-provider/provider";
import { territoryToCountryCode } from "$routes/_lib/constants";

/**
 * Returns the two-letter country code in uppercase
 */
export function useTerritoryCode() {
  const { territory } = useConfig();
  return territoryToCountryCode[territory];
}
